import { useLocalStorageState } from "ahooks"
import { SORT_OPTIONS } from "./TableView/DataTable/columnsConfig"

export type ViewMode = "list" | "table"

export type SortOrder = typeof SORT_OPTIONS[number]["serverOrder"]

const DEFAULT_SORT_ORDER: SortOrder = "first_name_asc"

const useGuestsViewSettings = () => {
  const [viewMode = "list", setViewMode] = useLocalStorageState<ViewMode>(
    "guestsPreferredViewMode",
    { defaultValue: "list" },
  )

  const [showStatusSummary = false, setShowStatusSummary] = useLocalStorageState<boolean>(
    "guestsShowStatusSummary",
    { defaultValue: false },
  )

  const [sortOrder = DEFAULT_SORT_ORDER, setSortOrder] = useLocalStorageState<SortOrder>(
    "guestsTableSortOrder",
    { defaultValue: DEFAULT_SORT_ORDER },
  )

  return {
    viewMode,
    setViewMode,
    showStatusSummary,
    setShowStatusSummary,
    sortOrder,
    setSortOrder,
  }
}

export default useGuestsViewSettings
